import CreateProgram from './CreateProgram';
import EditProgramme from './EditProgramme';
import Signup from './Signup';
import Dashboard from './Dashboard';
import Library from './Library';
import SingleClient from './SingleClient';
import Profile from './Profile';
import AddClient from './AddClient';
import EditClient from './EditClient';
import IndividProgramme from './IndividProgramme';
import MyAccount from './MyAccount';
import ViewUpdate from './ViewUpdate';
import ContactClient from './ContactClient';
import Feedback from './Feedback';
import ClientFeedback from './ClientFeedback';
import HowItWorks from './HowItWorks';
import ShareProgramme from './ShareProgramme';

export default {
  CreateProgram,
  Signup,
  Dashboard,
  Profile,
  SingleClient,
  Library,
  AddClient,
  EditClient,
  IndividProgramme,
  EditProgramme,
  MyAccount,
  ViewUpdate,
  ContactClient,
  Feedback,
  ClientFeedback,
  HowItWorks,
  ShareProgramme,
};
